import { IData } from "./DataStructure.js";
import { AppStorage } from "./AppStorage.js";

export type LanguageCode = "de" | "en";
export class Language {

    public static GERMAN: LanguageCode = "de";
    public static ENGLISH: LanguageCode = "en";
    public static onChange = e5.Signal.create<[LanguageCode]>();

    private static _current: LanguageCode = "en";

    public static data: IData = null;

    public static init(): void {
        //Get the language from the current system settings.
        Language._current = String(navigator.language || (<any>navigator).userLanguage).indexOf("de") !== -1 ? "de" : "en";

        //Get the language from Facebook bot
        if (e5.Url.params.has('fb_locale')) {
            Language._current = e5.Url.params.get("fb_locale") == "de_DE" ? "de" : "en";
        }
        //Get the language from the "lang" GET-parameter
        else if (e5.Url.params.has("lang")) {
            Language._current = e5.Url.params.get("lang") as LanguageCode;
        }
        //Get the language from local-storage
        else if (AppStorage.getItem("language")) {
            Language._current = AppStorage.getItem("language") as LanguageCode;
        }

        //Not valid language set? Than use "en".
        if (Language._current != "de" && Language._current != "en")
            Language._current = "en";

        $("body").on("click", ".language-button[data-lang=de]", () => this.current = "de");
        $("body").on("click", ".language-button[data-lang=en]", () => this.current = "en");
        this.update();

        AppStorage.setItem("language", Language._current);
    }

    public static label(element: HTMLElement, uiLabelKey: string, attr: string = ""): void {
        Language.apply(element,
            this.translate(uiLabelKey, Language.GERMAN),
            this.translate(uiLabelKey, Language.ENGLISH),
            attr);
    }

    public static translate(uiLabelKey: string, language: LanguageCode = Language.current, fallback: string = ""): string {
        if (!this.data) {
            console.warn("Could not translate ui-label. Language.data is null!");
            return "";
        }

        var spl = uiLabelKey.split(".");
        var title = spl.length > 1 ? spl[0] : "main";
        uiLabelKey = spl[1] || spl[0];
        for (var list of this.data.ui_label) {
            if (list.title == title) {
                for (var label of list.ui_labels) {
                    if (label.ui_label_key == uiLabelKey) {
                        var res = language == Language.GERMAN ? label.ui_label_de : label.ui_label_en;
                        return res || fallback;
                    }
                }
            }
        }
        return fallback;
    }

    public static get current(): LanguageCode {
        return Language._current;
    }

    public static set current(language: LanguageCode) {
        if (Language._current == language)
            return;
        Language._current = language;

        this.update();

        Language.onChange.dispatch(language);

        AppStorage.setItem("language", language);
    }

    private static update(): void {
        var language = this._current;

        // document.getElementById("app").setAttribute("data-language", language);
        // document.documentElement.setAttribute("lang", language);

        var fallbackLanguage = language == "de" ? "en" : "de";

        if (language == Language.ENGLISH) {
            $(".language-button[data-lang=de]").removeClass("selected");
            $(".language-button[data-lang=en]").addClass("selected");
        }
        else if (language == Language.GERMAN) {
            $(".language-button[data-lang=en]").removeClass("selected");
            $(".language-button[data-lang=de]").addClass("selected");
        }
        document.querySelectorAll("[data-en]").forEach((element: Element) => {
            var newText = element.getAttribute("data-" + language);
            if (!newText && fallbackLanguage && !element.getAttribute("data-nofallback")) {
                newText = element.getAttribute("data-" + fallbackLanguage);
            }
            var attr = element.getAttribute("data-lang-attr");
            if (!attr) {
                element.innerHTML = newText;
            }
            else
                element.setAttribute(attr, newText);
        });
        $("html").attr("lang", language);
    }

    public static trans(german: string, english: string): string {
        return Language.current == "de" ? german || english : english || german;
    }

    public static apply(element: HTMLElement, german: string, english: string, attr: string = ""): void {
        var newText = Language.current == "de" ? german || english : english || german;
        element.setAttribute("data-de", german);
        element.setAttribute("data-en", english);
        if (attr)
            element.setAttribute("data-lang-attr", attr);
        if (!attr)
            element.innerHTML = newText;
        else
            element.setAttribute(attr, newText);
    }

    public static applyNoFallback(element: HTMLElement, german: string, english: string, attr: string = ""): void {
        var newText = Language.current == "de" ? german : english;
        element.setAttribute("data-de", german);
        element.setAttribute("data-en", english);
        element.setAttribute("data-nofallback", "1");
        if (attr)
            element.setAttribute("data-lang-attr", attr);
        if (!attr)
            element.innerHTML = newText;
        else
            element.setAttribute(attr, newText);
    }
}